<div class="row edit-top-informations" *ngIf="aide">
  <div class="col-sm">Code : {{ aide.Code }}</div>
</div>
<form #form="ngForm" (ngSubmit)="formSubmit(form)" novalidate class="edit-aide" *ngIf="aide">
  <div class="form-group row">
    <div class="col-sm-12">
      <editor [init]="tinymceInit" [(ngModel)]="aide.Aide" id="aidecontrol" name="aidecontrol" ngDefaultControl></editor>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-12 text-right">
      <button type="button" class="btn btn-outline-danger btn-space-right" (click)="delete()"><i class="fa fa-trash-o" aria-hidden="true"></i> &nbsp; Supprimer</button>
      <button type="submit" class="btn btn-outline-primary btn-space-right" [disabled]="saveDisabled" (click)="setKeepOpen(true)"><i class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp; Enregistrer</button>
      <button type="submit" class="btn btn-outline-primary btn-space-right" [disabled]="saveDisabled" (click)="setKeepOpen(false)"><i class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp; Enregistrer et Fermer</button>
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()"><i class="fa fa-ban" aria-hidden="true"></i> &nbsp; Fermer</button>
    </div>
  </div>
</form>
